import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;

      &:after {
        top: 15px;
        left: 15px;
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 20px;
      left: 20px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = ['Python', 'SQL Server', 'Spring Boot', 'Angular', 'Node.js', 'PostgreSQL'];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">ACERCA DE MI</h2>

      <div className="inner">
        <StyledText>
          <div align="justify">
            <p>
              ¡Hola! Soy <a>Iván Nájera</a>, ingeniero en Tecnologías de la Información e ingeniero Industrial egresado de 
              DASC Instituto Tecnológico Universitario. Tengo una <a>Maestría</a> en Innovación y Gestión de Proyectos
              de Tecnologías de la Información cursado en DASC. Especializado en administración, automatización 
              y desarrollo e implementación de proyectos TI.
            </p>

            <p>
            Durante los últimos años me he desempeñado como Coordinador de Sistemas, soy responsable principalmente del
             <a>Desarrollo de nuevas tecnologias,</a> ERP y CRM , sistemas de control de acceso, desarrollo e implementación de proyectos TI, administración de 
            servidores Linux, administrador de base de datos en <a>SQL y NoSQL</a>, capacitaciones y en los desarrollos 
            aplicando metodologias <a>SCRUM, ITIL</a>, ocasionalmente doy soporte al equipo informático. 
            </p>

            <p>
            Soy una persona <a>proactiva</a> que siempre ofrece soluciones con los recursos disponibles, me gusta estar en constante 
            aprendizaje para implementar soluciones innovadoras.
            </p>

            <p>Tecnologías con las que he estado trabajando recientemente:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              // src="../../images/ivan.JPG"
              src="../../images/perfil.jpeg"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
